export default __webpack_public_path__ + "static/media/800.79ba7755.woff2";